// noinspection JSUnusedGlobalSymbols

export default class
{
	static show_extra()
	{
		const current = Number($('input[name="current_cash"]').val())
		const prepared = Number($('input[name="prepared_cash"]').val())

		const total = Number($('#total').data('total'))
		const extra = current - prepared - total

		if(extra !== 0) $('#extra, #extra_unit').addClass('text-red-500')
		else $('#extra, #extra_unit').removeClass('text-red-500')

		$('#extra').text(extra.toLocaleString())
	}
}
